import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { getJson } from '../helpers/RequestsHelper'

import ApplicationIcon from '../components/ApplicationIcon';
import AccountsList from '../components/AccountsList';
import Vote from '../components/Vote';

import SelectObject from './WorkflowComponents/Inputs/SelectObject'
import AccountConnectComponent from '../components/AccountConnectComponent';

import { withTranslation } from 'react-i18next';

import { initializeApps, publicApps, underCertificationApps, getVotes, externalApps } from '../helpers/applications'

class ApplicationsPage extends Component {
    state = {
        selectedAddApp: undefined
    }

    constructor(props) {
        super(props)

        this.onAddApplicationSelect = this.onAddApplicationSelect.bind(this)
    }

    componentDidMount() {
        const { t } = this.props;
        document.title = t("titleappname") + t("title_apps")
    }

    onAddApplicationSelect(selectedAddApp) {
        this.setState({ selectedAddApp });
    }

    render() {
        let addApplication = ""
        const selectedAddApp = this.state.selectedAddApp
        if (selectedAddApp) {
            const applicationId = selectedAddApp.id
            let type = applicationId
            if (applicationId.startsWith("google")) {
                type = "google"
            }
            addApplication = <div key={"add" + applicationId} >
                <AccountConnectComponent account={{ type: applicationId, accountId: type }} new="true" />
            </div>
        }

        return <div>
            <h3>Applications</h3>
            <br />
            Search for and select an application to add
            <table><tbody><tr><td  style={{width: this.props.windowWidth > 993? "400px" : this.props.isLegacy? "400px" : "100%"}}>
            <SelectObject 
            // groups={[
            //     { name: "Applications", items: publicApps }, 
            //     { name: "Awaiting Certification", items: underCertificationApps }
            // ]} 
            items={externalApps}
            fieldName="name" 
            onSelect={this.onAddApplicationSelect} 
            selected={this.state.selectedAddApp} />
            </td><td>{addApplication}</td></tr></tbody>
            </table>
            <br />
            <br />
            <div className="apps-group">
                <p className="apps-group-title">My Applications</p>
                <AccountsList />
            </div>

            <br />

            <div className="apps-group">
                <p className="apps-group-title">Recommended for me</p>
                <div className="d-flex row">
                    <div className="p-2"><ApplicationIcon appType="googlesheets" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="googleforms" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="googlegmail" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="slack" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="asana" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="trello" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="docusign" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="onedrive" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="twitter" className="large-icon" /></div>
                </div>
            </div>

            <br />

            <div className="apps-group">
                <p className="apps-group-title">Simply Flows Applications</p>
                <div className="d-flex row">
                    <div className="p-2"><ApplicationIcon appType="simplyflows_merge" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_filter" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_sendemail" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_sms" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_stop" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_pause" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_delay" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_convert" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_foreach" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_crypto" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_finance" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="simplyflows_input" className="large-icon" /></div>
                </div>
            </div>

            <br />

            <div className="apps-group">
                <p className="apps-group-title">More Applications</p>
                <div className="d-flex row">
                <div className="p-2"><ApplicationIcon appType="alphavantage" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="defipulse" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="finnhub" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="toggltrack" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="twilio" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="sendgrid" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="googlecalendar" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="googledrive" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="airtable" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="sendinblue" className="large-icon" /></div>
                    <div className="p-2"><ApplicationIcon appType="mongodbatlas" className="large-icon" /></div>
                    
                    
                </div>
            </div>

            <br />

            <div className="apps-group">
                <p className="apps-group-title">Coming Soon</p>
                <div className="d-flex row">
                    <div className="p-2"><ApplicationIcon appType="linkedin" className="large-icon" /><Vote votes={getVotes("linkedin")} type="application" docId="linkedin" /></div>
                    <div className="p-2"><ApplicationIcon appType="msteams" className="large-icon" /><Vote votes={getVotes("msteams")} type="application" docId="msteams" /></div>
                    <div className="p-2"><ApplicationIcon appType="hubspot" className="large-icon" /><Vote votes={getVotes("hubspot")} type="application" docId="hubspot" /></div>
                    <div className="p-2"><ApplicationIcon appType="mailchimp" className="large-icon" /><Vote votes={getVotes("mailchimp")} type="application" docId="mailchimp" /></div>
                    <div className="p-2"><ApplicationIcon appType="salesforce" className="large-icon" /><Vote votes={getVotes("salesforce")} type="application" docId="salesforce" /></div>
                    <div className="p-2"><ApplicationIcon appType="facebook" className="large-icon" /><Vote votes={getVotes("facebook")} type="application" docId="facebook" /></div>
                    <div className="p-2"><ApplicationIcon appType="wordpress" className="large-icon" /><Vote votes={getVotes("wordpress")} type="application" docId="wordpress" /></div>
                    <div className="p-2"><ApplicationIcon appType="shopify" className="large-icon" /><Vote votes={getVotes("shopify")} type="application" docId="shopify" /></div>
                    <div className="p-2"><ApplicationIcon appType="smartsheet" className="large-icon" /><Vote votes={getVotes("smartsheet")} type="application" docId="smartsheet" /></div>
                </div>
            </div>

            <br />

            {/* {this.state.underCertificationApps ?
                <div className="apps-group">
                    <p className="apps-group-title">Awaiting certification</p>
                    <div className="d-flex row">
                        {this.state.underCertificationApps.map((app) =>
                            <div className="p-2">
                                <ApplicationIcon appType={app.id.startsWith("google") ? "google" : app.id} className="large-icon" name={app.name} /><Vote votes={getVotes(app.id)} type="application" docId={app.id} /></div>
                        )}
                    </div>
                </div>
                : ""} */}
        </div>
    }

}

export default withRouter(withTranslation()(ApplicationsPage), ApplicationsPage);